module.exports = __webpack_public_path__ + "static/myupreach-0aa5d44c93e292098fa2f09c69511d64.jpg";